import { IMatchDetailDTO } from "../models/IMatch";

export const useBracketTree = (matches: IMatchDetailDTO[]) => {
  const matchMap = new Map(matches.map((m) => [m.id, m]));

  // Find final match
  const finalMatch = matches.find((m) => m.round === "Final") || null;

  if (!finalMatch) {
    return { leftRounds: [], rightRounds: [], finalMatch: null, thirdPlaceMatch: null };
  }

  // Recursively collect rounds
  const collectRounds = (matchId: string, depth: number, rounds: Map<number, IMatchDetailDTO[]>) => {
    const match = matchMap.get(matchId);
    if (!match) return;

    if (!rounds.has(depth)) rounds.set(depth, []);
    rounds.get(depth)!.push(match);

    if (match.parentMatch1Id) collectRounds(match.parentMatch1Id, depth + 1, rounds);
    if (match.parentMatch2Id) collectRounds(match.parentMatch2Id, depth + 1, rounds);
  };

  const rounds = new Map<number, IMatchDetailDTO[]>();
  collectRounds(finalMatch.id, 0, rounds);

  // Convert map -> sorted array
  const sortedRounds = Array.from(rounds.entries())
    .sort(([a], [b]) => b - a) // deepest first
    .map(([_, ms]) => ms);

  // Drop the final (depth 0) so it won't duplicate
  sortedRounds.pop();

  // Split each round into left/right
  const leftRounds: IMatchDetailDTO[][] = [];
  const rightRounds: IMatchDetailDTO[][] = [];

  sortedRounds.forEach((roundMatches) => {
    const mid = Math.ceil(roundMatches.length / 2);
    leftRounds.push(roundMatches.slice(0, mid));
    rightRounds.push(roundMatches.slice(mid));
  });

  // Third place
  const thirdPlaceMatch = matches.find((m) => m.round === "Third Place") || null;

  return { leftRounds, rightRounds, finalMatch, thirdPlaceMatch };
};
